module.exports = __webpack_public_path__ + "img/Support-skill-521.2d60e6b9.png";